import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlColRaccResponse extends IIsiDtoPresentationLogicResponse  {
    raccourci?: string;
}
export class IsiDtoPlColRaccResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlColRaccResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.ColRacc.IsiDtoPlColRaccResponse, Isilog.IsiComponent.IsiDataTransferObject";
    raccourci?: string;

    constructor(data?: IIsiDtoPlColRaccResponse) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.raccourci = _data["raccourci"] !== undefined ? _data["raccourci"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlColRaccResponse): IsiDtoPlColRaccResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlColRaccResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["raccourci"] = this.raccourci !== undefined ? this.raccourci : <any>null;
        return data;
    }
}
export interface IIsiDtoPlColRaccRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlColRaccResponse;
    gridViewId?: string;
    columnName?: string;
}
export class IsiDtoPlColRaccRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlColRaccRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.ColRacc.IsiDtoPlColRaccRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlColRaccResponse;
    gridViewId?: string;
    columnName?: string;

    constructor(data?: IIsiDtoPlColRaccRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlColRaccResponse(data.response) : <IsiDtoPlColRaccResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlColRaccResponse.fromJS(_data["response"]) : <any>null;
            this.gridViewId = _data["gridViewId"] !== undefined ? _data["gridViewId"] : <any>null;
            this.columnName = _data["columnName"] !== undefined ? _data["columnName"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlColRaccRequest): IsiDtoPlColRaccRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlColRaccRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["gridViewId"] = this.gridViewId !== undefined ? this.gridViewId : <any>null;
        data["columnName"] = this.columnName !== undefined ? this.columnName : <any>null;
        return data;
    }
}
